export const CreditStepsTexts = {
  title: 'Как получить кредит',
};
